/** @file depthOffsetOf: the extra z-order a facet entry adds for the picked sector's sideBack class. */
import type { FacetEntry } from '@zilo/pose3d-format/types/facet';

/** 0 for front (0); `depth.side` for side (1); `depth.back` for back (2); 0 when absent. */
export function depthOffsetOf(entry: FacetEntry, sideBack: 0 | 1 | 2): number {
  if (sideBack === 1) return entry.depth?.side ?? 0;
  if (sideBack === 2) return entry.depth?.back ?? 0;
  return 0;
}
